// @flow

import React from "react";
import { Field } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";
import { getClassName } from "ui-kit/utils/component";
import { Input, Button } from "ui-kit/components";

import "./Form.scss";

const ccn = getClassName("CurrencyForm");

const CurrencyForm = ({
  invest,
  onInputChange,
  invalid,
  setValue,
  currency,
  intl: { formatMessage }
}) => (
  <div className={ccn()}>
    <div className={ccn("form-group")}>
      <Field
        component={Input}
        name="amount"
        type="text"
        min="1"
        unit={currency}
        unitPosition="left"
        onChange={onInputChange}
        placeholder="0"
        label={formatMessage({ id: "hbc.invest.input", defaultMessage: "Enter the amount:" })}
        val={setValue}
      />
    </div>
    <div className={ccn("btnWrap")}>
      <Button
        onClick={invest}
        round={true}
        primary={true}
        className={`Button--invest-submit ${
          invalid || setValue === 0 ? "Button--invest-submit--disabled" : ""
        }`}
        disabled={invalid}
      >
        <FormattedMessage id="hbc.invest.submit" defaultMessage="Submit" />
      </Button>
    </div>
  </div>
);

export default injectIntl(CurrencyForm);



// WEBPACK FOOTER //
// ./src/containers/invest/form/Form.js